import React from 'react';
import NumberInput from '~ComponentsImproved/Numpad';

export const DeveloperKeypass = ({
  open,
  onClose,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (value: string) => void;
}) => {
  if (open) {
    return <NumberInput onSubmit={onSubmit} onClose={onClose} />;
  } else {
    return null;
  }
};
